import './i18n'
import './index.css'
import { ViteReactSSG } from 'vite-react-ssg'
import routes from './router/config'

declare const __BASE_PATH__: string

export const createRoot = ViteReactSSG({
  routes,
  basename: __BASE_PATH__,
})
 